import React, { useState } from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import ReportBonusFilter from './ReportBonusFilter';
import ReportBonusTable from './ReportBonusTable';
import { Stack } from '@mui/material';
import ErrorBoundary from '../../../components/material-ui/error_boundary/ErrorBoundary';

export default function ReportBonuses() {
  const [loader, setLoader] = useState(false);
  const [empty, setEmpty] = useState(false);

  return (
    <CusPageCardContainer title={'Bonus reports'}>
      <Stack gap={3}>
        <ErrorBoundary>
          <ReportBonusFilter setLoader={setLoader} setEmpty={setEmpty} />
        </ErrorBoundary>
        <ErrorBoundary>
          <ReportBonusTable loader={loader} empty={empty} />
        </ErrorBoundary>
      </Stack>
    </CusPageCardContainer>
  );
}
